<template>
  <div class="testreportpage">
      <van-nav-bar
            title="我的测评"
            left-arrow
            @click-left="onClickLeft"
        />
        <div v-if="reportList && reportList.length>0" class="reportlist">
            <ul>
                <li @click="goreport(item)" v-for="(item, index) in reportList" :key="index">
                    <div>
                        <h3>
                            {{item.assessName}}
                            <!-- 千万别删！！！ -->
                            <!-- <span v-if="item.modelType">{{item.modelType===1?'素质':'专业'}}</span> -->
                        </h3>
                        <p>{{item.assessDate}}</p>
                    </div>
                    <img src="../../../assets/images/exam/jinru.png" alt="">
                </li>
            </ul>
        </div>
        <div v-else class="noOrder">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/account/noorder%403x.png" alt="">
            <p>还没有测评报告呦，赶快去测评吧～</p>
        </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'testreport',
    data() {
        return {
            reportList: [],
            reportData: {
                total: 0,
            },
        }
    },
    computed: {
		...mapState(['isNewSaas']),
	},
    components: {

    },
    created() {
        this.getreportList();
    },
    methods: {
        goreport(val){
            this.$router.push({
                path: "/reportdetail",
                query: {
                    resultId: val.id,
                }
            })
        },
        onClickLeft() {
            if(this.isNewSaas){
                this.$router.push({
                    path: '/personalCenter_new'
                });
            }else{
                this.$router.push({
                    path: '/saccount'
                });
            }
        },
        getreportList(){
            let params = {
                pageSize: 999, 
                pageNum: 1
            }
            this.$api.testreport.reportList({params}).then(res => {
                this.reportList = res.data.list;
            });
        }
    },
    mounted() {

    }
}
</script>

<style scoped lang="less">
@import '../asset/css/testreport.less';
</style>
